// Generated by lighthouse-icons/config/bundle.js
import * as React from "react";
import { default as IconComponentAcademicCap } from './AcademicCap.js';
import { default as IconComponentBalancingBall } from './BalancingBall.js';
import { default as IconComponentBarChart } from './BarChart.js';
import { default as IconComponentBuildingWithPlant } from './BuildingWithPlant.js';
import { default as IconComponentCalendar } from './Calendar.js';
import { default as IconComponentCar } from './Car.js';
import { default as IconComponentChatBubble } from './ChatBubble.js';
import { default as IconComponentCircleAndSquare } from './CircleAndSquare.js';
import { default as IconComponentCircleWithChart } from './CircleWithChart.js';
import { default as IconComponentCirclesCutout } from './CirclesCutout.js';
import { default as IconComponentCirclesOverlapping } from './CirclesOverlapping.js';
import { default as IconComponentCompass } from './Compass.js';
import { default as IconComponentConfetti } from './Confetti.js';
import { default as IconComponentDocumentWithPen } from './DocumentWithPen.js';
import { default as IconComponentDocumentWithTarget } from './DocumentWithTarget.js';
import { default as IconComponentDocuments } from './Documents.js';
import { default as IconComponentEnVeiInn } from './EnVeiInn.js';
import { default as IconComponentEnvelopeOpen } from './EnvelopeOpen.js';
import { default as IconComponentExclamation } from './Exclamation.js';
import { default as IconComponentFlag } from './Flag.js';
import { default as IconComponentGlobe } from './Globe.js';
import { default as IconComponentGrain } from './Grain.js';
import { default as IconComponentHeart } from './Heart.js';
import { default as IconComponentInnovasjonNorge } from './InnovasjonNorge.js';
import { default as IconComponentLock } from './Lock.js';
import { default as IconComponentMagnifyingGlass } from './MagnifyingGlass.js';
import { default as IconComponentMicrophone } from './Microphone.js';
import { default as IconComponentMicroscope } from './Microscope.js';
import { default as IconComponentMoneyCoins } from './MoneyCoins.js';
import { default as IconComponentMountains } from './Mountains.js';
import { default as IconComponentPeople } from './People.js';
import { default as IconComponentPerson } from './Person.js';
import { default as IconComponentPersonWithHouse } from './PersonWithHouse.js';
import { default as IconComponentPieChart } from './PieChart.js';
import { default as IconComponentQuote } from './Quote.js';
import { default as IconComponentRocket } from './Rocket.js';
import { default as IconComponentSailboat } from './Sailboat.js';
import { default as IconComponentShieldDiagonal } from './ShieldDiagonal.js';
import { default as IconComponentShieldVertical } from './ShieldVertical.js';
import { default as IconComponentShip } from './Ship.js';
import { default as IconComponentSquaresOverlapping } from './SquaresOverlapping.js';
import { default as IconComponentTarget } from './Target.js';
import { default as IconComponentTime } from './Time.js';
import { default as IconComponentTrophy } from './Trophy.js';
const Icon = (props) => {
    let ResolvedComponent;
    switch (props.name) {
        case 'AcademicCap':
        case 'academic-cap':
            ResolvedComponent = IconComponentAcademicCap;
            break;
        case 'BalancingBall':
        case 'balancing-ball':
            ResolvedComponent = IconComponentBalancingBall;
            break;
        case 'BarChart':
        case 'bar-chart':
            ResolvedComponent = IconComponentBarChart;
            break;
        case 'BuildingWithPlant':
        case 'building-with-plant':
            ResolvedComponent = IconComponentBuildingWithPlant;
            break;
        case 'Calendar':
        case 'calendar':
            ResolvedComponent = IconComponentCalendar;
            break;
        case 'Car':
        case 'car':
            ResolvedComponent = IconComponentCar;
            break;
        case 'ChatBubble':
        case 'chat-bubble':
            ResolvedComponent = IconComponentChatBubble;
            break;
        case 'CircleAndSquare':
        case 'circle-and-square':
            ResolvedComponent = IconComponentCircleAndSquare;
            break;
        case 'CircleWithChart':
        case 'circle-with-chart':
            ResolvedComponent = IconComponentCircleWithChart;
            break;
        case 'CirclesCutout':
        case 'circles-cutout':
            ResolvedComponent = IconComponentCirclesCutout;
            break;
        case 'CirclesOverlapping':
        case 'circles-overlapping':
            ResolvedComponent = IconComponentCirclesOverlapping;
            break;
        case 'Compass':
        case 'compass':
            ResolvedComponent = IconComponentCompass;
            break;
        case 'Confetti':
        case 'confetti':
            ResolvedComponent = IconComponentConfetti;
            break;
        case 'DocumentWithPen':
        case 'document-with-pen':
            ResolvedComponent = IconComponentDocumentWithPen;
            break;
        case 'DocumentWithTarget':
        case 'document-with-target':
            ResolvedComponent = IconComponentDocumentWithTarget;
            break;
        case 'Documents':
        case 'documents':
            ResolvedComponent = IconComponentDocuments;
            break;
        case 'EnVeiInn':
        case 'en-vei-inn':
            ResolvedComponent = IconComponentEnVeiInn;
            break;
        case 'EnvelopeOpen':
        case 'envelope-open':
            ResolvedComponent = IconComponentEnvelopeOpen;
            break;
        case 'Exclamation':
        case 'exclamation':
            ResolvedComponent = IconComponentExclamation;
            break;
        case 'Flag':
        case 'flag':
            ResolvedComponent = IconComponentFlag;
            break;
        case 'Globe':
        case 'globe':
            ResolvedComponent = IconComponentGlobe;
            break;
        case 'Grain':
        case 'grain':
            ResolvedComponent = IconComponentGrain;
            break;
        case 'Heart':
        case 'heart':
            ResolvedComponent = IconComponentHeart;
            break;
        case 'InnovasjonNorge':
        case 'innovasjon-norge':
            ResolvedComponent = IconComponentInnovasjonNorge;
            break;
        case 'Lock':
        case 'lock':
            ResolvedComponent = IconComponentLock;
            break;
        case 'MagnifyingGlass':
        case 'magnifying-glass':
            ResolvedComponent = IconComponentMagnifyingGlass;
            break;
        case 'Microphone':
        case 'microphone':
            ResolvedComponent = IconComponentMicrophone;
            break;
        case 'Microscope':
        case 'microscope':
            ResolvedComponent = IconComponentMicroscope;
            break;
        case 'MoneyCoins':
        case 'money-coins':
            ResolvedComponent = IconComponentMoneyCoins;
            break;
        case 'Mountains':
        case 'mountains':
            ResolvedComponent = IconComponentMountains;
            break;
        case 'People':
        case 'people':
            ResolvedComponent = IconComponentPeople;
            break;
        case 'Person':
        case 'person':
            ResolvedComponent = IconComponentPerson;
            break;
        case 'PersonWithHouse':
        case 'person-with-house':
            ResolvedComponent = IconComponentPersonWithHouse;
            break;
        case 'PieChart':
        case 'pie-chart':
            ResolvedComponent = IconComponentPieChart;
            break;
        case 'Quote':
        case 'quote':
            ResolvedComponent = IconComponentQuote;
            break;
        case 'Rocket':
        case 'rocket':
            ResolvedComponent = IconComponentRocket;
            break;
        case 'Sailboat':
        case 'sailboat':
            ResolvedComponent = IconComponentSailboat;
            break;
        case 'ShieldDiagonal':
        case 'shield-diagonal':
            ResolvedComponent = IconComponentShieldDiagonal;
            break;
        case 'ShieldVertical':
        case 'shield-vertical':
            ResolvedComponent = IconComponentShieldVertical;
            break;
        case 'Ship':
        case 'ship':
            ResolvedComponent = IconComponentShip;
            break;
        case 'SquaresOverlapping':
        case 'squares-overlapping':
            ResolvedComponent = IconComponentSquaresOverlapping;
            break;
        case 'Target':
        case 'target':
            ResolvedComponent = IconComponentTarget;
            break;
        case 'Time':
        case 'time':
            ResolvedComponent = IconComponentTime;
            break;
        case 'Trophy':
        case 'trophy':
            ResolvedComponent = IconComponentTrophy;
            break;
    }
    return (React.createElement("span", { className: props.className, "aria-label": props.altText },
        React.createElement(ResolvedComponent, null)));
};
export default Icon;
//# sourceMappingURL=Icon.js.map